export default __webpack_public_path__ + "static/media/ic_check_right.12693f5f.svg";